__webpack_require__.p = "/pokergpt/";